import { useContext } from "react";

import { AuthContext } from "./auth.context.js";

export function useAuth() {
  const context = useContext(AuthContext);

  if (!context.__ctx_init) {
    throw new Error("useAuth was called before auth finished initializing");
  }

  if (!(context.user && context.accessToken && context.providerName)) {
    throw new Error("useAuth requires an authenticated session");
  }

  return {
    accessToken: context.accessToken,
    providerName: context.providerName,
    user: context.user,
  };
}
